import React, {useContext, useState} from 'react';
import { Chip, Popover, MenuItem } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import {useDispatch, useSelector} from "react-redux";
import {getQuoteStatusesStatus, patchQuoteStatus, selectGetQuoteStatuses} from "../../redux/ProjectsSlice";
import {useTheme} from "@mui/material/styles";
import {enqueueSnackbar, SnackbarProvider } from 'notistack';
import {IsOnboardedContext} from "../../Contexts/IsOnboardedContext";

function ProjectStatusChip({quoteId, quoteStatus}) {
    const theme = useTheme();
    const dispatch = useDispatch();
    
    const quoteStatuses = useSelector(selectGetQuoteStatuses);
    const quoteStatusesLoadingStatus = useSelector(getQuoteStatusesStatus);

    const [anchorEl, setAnchorEl] = useState(null);
    const [chipLabel, setChipLabel] = useState(quoteStatus);
    const context = useContext(IsOnboardedContext);
    
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (value) => {
        if (typeof value === 'string') {
            setAnchorEl(null);
        }
        else if (typeof value === 'object') {
            if (chipLabel !== value.displayName) {
                setChipLabel(value.displayName);
                setAnchorEl(null);
                dispatch(patchQuoteStatus(
                    {
                        id: quoteId, payload: 
                            {
                                quoteStatus: value.enumInt,
                                quoteStatusAsText: value.displayName,
                                updatedBy:  context.userName
                            }
                    } 
                )).unwrap()
                    .then(() => {
                        enqueueSnackbar('Status successfully updated', { variant: 'success' } );
                })
                    .catch((error) => {
                        console.error('Failed to update quote status', error);
                        enqueueSnackbar('Failed to update status. Please refresh and try again.', { variant: 'error' } );
                    });
            } else {
                setAnchorEl(null);
            }
        }
    };

    const getBackgroundColor = () => {
        const status = quoteStatuses.find(status => status.displayName === chipLabel);
        return status?.variant === 'outlined'
            ? theme.palette.background.default : 
            theme.palette[status?.color]?.secondary;
    };

    const getOutlineColor = () => {
        const status = quoteStatuses.find(status => status.displayName === chipLabel);
        return theme.palette[status?.color]?.main;
    };

    const open = Boolean(anchorEl);
    
    return (
        <div>
            <SnackbarProvider maxSnack={3}/>
            <Chip
                label={chipLabel}
                onClick={handleClick}
                variant="outlined"
                icon={<ArrowDropDownIcon />}
                sx={{
                    backgroundColor: getBackgroundColor(),
                    borderColor: getOutlineColor(),
                    fontWeight: 'bold',
                    fontSize: '1rem'
                }}
            />
            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={() => handleClose(chipLabel)}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                {quoteStatusesLoadingStatus === 'succeeded' ? 
                    quoteStatuses.map((status, index) => {
                    return (
                        <MenuItem 
                            key={index} 
                            onClick={() => handleClose(status)}
                            sx={{
                                fontSize: '1rem'
                            }}
                        >
                            {status.displayName}
                        </MenuItem>
                    )
                }) : (quoteStatusesLoadingStatus === 'loading' 
                        ? (<MenuItem disabled>Loading...</MenuItem>)
                : (<MenuItem disabled>Failed to retrieve statuses</MenuItem>)
                )}
                </Popover>
        </div>
    );
}

export default ProjectStatusChip;